import React, { useState } from 'react'
import SettingsIcon from '@mui/icons-material/Settings';
import { TiHome } from 'react-icons/ti'
import { MdLibraryBooks, MdSupervisorAccount, MdLocalActivity, MdBlock } from 'react-icons/md'
import { IoIosNotifications } from 'react-icons/io'
import { FiPhoneCall } from 'react-icons/fi'
import { TbVersions, TbWorld } from 'react-icons/tb'
import { BsShieldLock } from 'react-icons/bs'
import { FaUsers, FaRoute, FaUserAlt, FaMoneyBillWave } from 'react-icons/fa';
import { FcDepartment } from 'react-icons/fc';
import { RiShieldStarLine } from 'react-icons/ri'
import { useHistory } from 'react-router-dom'
import { IoMdConstruct, IoIosCard } from 'react-icons/io'
import { BiLogOut, BiDevices, BiPhoneCall } from 'react-icons/bi'
import { HiDocumentReport } from 'react-icons/hi'
import Sidebaritem from './sidebar-item/Sidebar-item';
import { connect, useSelector } from "react-redux";
import { ImListNumbered } from 'react-icons/im'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import { FaUserTie, FaUserTag, FaSms, FaMoneyBillAlt } from "react-icons/fa";
import { VscFeedback } from 'react-icons/vsc'
import { VscError } from 'react-icons/vsc'
import Loader from "../../components/Loader"
import { FcIdea } from 'react-icons/fc'
import { TiTicket } from 'react-icons/ti'
import { CgPerformance } from 'react-icons/cg'
import { AiOutlineSetting } from 'react-icons/ai'
import { FaFileInvoice } from 'react-icons/fa'
import { BiNotepad } from 'react-icons/bi'
import { SiGnuprivacyguard } from 'react-icons/si'
import { FiSettings } from 'react-icons/fi'
import { MdSubscriptions } from "react-icons/md"; // Subscription icon import
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import * as popUpActionCreator from "../../store/Actions/popup-actionCreator";
import { BiRightTopArrowCircle, BiArea, BiRightDownArrowCircle, BiCommentDots } from "react-icons/bi";
import PeopleIcon from '@mui/icons-material/People';
import { BiDollarCircle } from 'react-icons/bi'
import './sidebar.css'
import axiosInstance from "../../environment/axiosInstances";

function SidebarComponent(props: any) {
  const history = useHistory()
  const [simpleLinks, setSimpleLinks] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<any>(true);
  const [numberValidateErrors, setNumberValidateErrors] = useState(null);
  const navigateRoute = (url: any) => {
    history.push(url)
  }

  const userStateData = useSelector((state: any) => state.authState)

  // React.useEffect(() => {
  //   if(simpleLinks.length === 0){
  //     setLoading(true)
  //   }else{
  //     setLoading(false)
  //   }
  //   setSimpleLinks(simpleLinks)
  //   console.log("simpleLonks",simpleLinks)
  // },[simpleLinks])

  React.useEffect(() => {
    setLoading(true)
    if (Object.keys(props.userPermission).length) {
      setSimpleLinks([
        {
          status: 1,
          pathTo: "/",
          title: "Dashboard",
          icon: { Icon: TiHome, size: 21 },
          routes: [],
        },
        // {
        //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[0].efoneClients.list : 0,
        //   pathTo: "/efone-clients",
        //   title: "Efone clients",
        //   icon: { Icon: MdSupervisorAccount, size: 21 },
        //   routes: [],
        // },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[18].businessClients.list ||
            props.userPermission[31].invoices.list || props.userPermission[32].disputes.list ||
            props.userPermission[33].signupActivations.list || props.userPermission[34].addonSummary.list ? 1 : 0 : 0,

          title: "Business",
          icon: { Icon: TiHome, size: 21 },
          routes: [
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[18].businessClients?.list : 0,
              pathTo: '/licenses',
              title: "Licenses",
              icon: { Icon: MdSupervisorAccount, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[18].businessClients?.list : 0,
              pathTo: '/business',
              title: "Clients",
              icon: { Icon: MdSupervisorAccount, size: 21 },
              routes: [],

            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[31].invoices?.list : 0,
              pathTo: "/business-invoices",
              title: "Invoices",
              icon: { Icon: FaFileInvoice, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[32].disputes?.list : 0,
              pathTo: "/business-disputes",
              title: "Disputes",
              icon: { Icon: MdBlock, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[33].signupActivations?.list : 0,
              pathTo: "/business-signup-activations",
              title: "Signup Activations",
              icon: { Icon: SiGnuprivacyguard, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[33].addons?.list : 0,
              pathTo: "/business-addons",
              title: "Addons",
              icon: { Icon: SiGnuprivacyguard, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[34].addonSummary?.list : 0,
              pathTo: "/business-addonsummary",
              title: "Addons Summary",
              icon: { Icon: BiNotepad, size: 21 },
              routes: [],
            },
          ],
        },
        {
          status: 1,
          title: "V5",
          icon: { Icon: TbVersions, size: 21 },
          routes: [
            {
              status: 1,
              pathTo: '/v5/dashboard',
              title: "Dashboard",
              icon: { Icon: TiHome, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: '/v5/clients',
              title: "Clients",
              icon: { Icon: MdSupervisorAccount, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/v5/reports/user-lifecycle",
              title: "User Lifecycle",
              icon: { Icon: PeopleIcon, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/v5/push-campaigns",
              title: "Push Campaigns",
              icon: { Icon: IoIosNotifications, size: 21 },
              routes: [],
            },
            // {
            //   status: 1,
            //   pathTo: '/v5/call-rates',
            //   title: "Call Rates",
            //   icon: { Icon: MdSupervisorAccount, size: 21 },
            //   routes: [],
            // },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[10].reports.calls ||
                  props.userPermission[10].reports.sms ||
                  props.userPermission[10].reports.usage ? 1 : 0 : 0,
              pathTo: "/v5/reports/calls",
              title: "Client Reports",
              icon: { Icon: FaUserTie, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[4].phoneNumbers.list ||
                  props.userPermission[4].phoneNumbers.port ||
                  props.userPermission[4].phoneNumbers.purchase ? 1 : 0 : 0,
              pathTo: "/v5/phone-numbers",
              title: "Phone Numbers",
              icon: { Icon: BiPhoneCall, size: 21 },
              routes: [],
            },
            // {
            //   status: 1,
            //   pathTo: '/plans',
            //   title: "Plans",
            //   icon: { Icon: FaMoneyBillWave, size: 21 },
            //   routes: [],
            // },
            // {
            //   status: 1,
            //   pathTo: '/features',
            //   title: "Features",
            //   icon: { Icon: MoneyOffIcon, size: 21 },
            //   routes: [],
            // },
            {
              status: 1,
              pathTo: "/e911",
              title: "E911",
              icon: { Icon: MdSubscriptions, size: 21 },
              routes: [],
            },
            // {
            //   status: 1,
            //   pathTo: '/users',
            //   title: "Users",
            //   icon: { Icon: FaUserAlt, size: 21 },
            //   routes: [],
            // },
            {
              status: 1,
              pathTo: "/settings",
              title: "Settings",
              icon: { Icon: FiSettings, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/subscriptions",
              title: " subscriptions",
              icon: { Icon: MdSubscriptions, size: 21 },
              routes: [],
            },

            {
              status: 1,
              pathTo: "/v5/specialRouting",
              title: "Special Routing",
              icon: { Icon: FiSettings, size: 21 },
              routes: [],
            },
          ],


        },
        {
          status: 1,
          title: "Home Phones",
          icon: { Icon: BiPhoneCall, size: 21 },
          routes: [
            {
              status: 1,
              pathTo: "/home-phones/products",
              title: "Home Phone",
              icon: { Icon: BiDevices, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/home-phones/orders",
              title: "Orders",
              icon: { Icon: FaFileInvoice, size: 21 },
              routes: [],
            },
          ],
        },
        // {
        //   status: 1,
        //   //pathTo:'/international-calling',
        //   title: 'International Calling',
        //   icon: { Icon: TbWorld, size: 21 },
        //   routes: [
        //     // {
        //     //   status: 1,
        //     //   pathTo: "/international-calling/dashboard",
        //     //   title: "Dashboard",
        //     //   icon: { Icon: TiHome, size: 21 },
        //     //   routes: [],
        //     // },
        //     {
        //       status: 1,
        //       pathTo: "/international-calling/clients",
        //       title: "Clients",
        //       icon: { Icon: MdSupervisorAccount, size: 21 },
        //       routes: [],
        //     },
        //     {
        //       status: 1,
        //       pathTo: "/international-calling/packages",
        //       title: "Packages",
        //       icon: { Icon: BiDollarCircle, size: 21 },
        //       routes: [],
        //     },
        //     {
        //       status: 1,
        //       pathTo: "/international-calling/reports",
        //       title: "Reports",
        //       icon: { Icon: HiDocumentReport, size: 21 },
        //       routes: [],
        //     },
        //     {
        //       status: 1,
        //       pathTo: "/international-calling/settings",
        //       title: "Settings",
        //       icon: { Icon: FiSettings, size: 21 },
        //       routes: [],
        //     },
        //     {
        //       status: 1,
        //       pathTo: "/international-calling/notifications",
        //       title: "Notifications",
        //       icon: { Icon: IoIosNotifications, size: 21 },
        //       routes: [],
        //     },
        //   ],
        // },
        {
          status: props.userPermission.length > 0 ?
            props.userPermission[1].agents.list ||
              props.userPermission[2].departments.list ||
              props.userPermission[3].profiles.list ? 1 : 0 : 0,
          title: "Admin Users",
          icon: { Icon: MdLibraryBooks, size: 21 },
          routes: [
            {
              status: props.userPermission.length > 0 ? props.userPermission[1].agents.list : 0,
              pathTo: "/agents",
              title: "Agents",
              icon: { Icon: FaUsers, size: 21 },
              routes: [],
            },
            {
              status: props.userPermission.length > 0 ? props.userPermission[2].departments.list : 0,
              pathTo: "/departments",
              title: "Departments",
              icon: { Icon: FcDepartment, size: 21 },
              routes: [],
            },
            {
              status: props.userPermission.length > 0 ? props.userPermission[3].profiles.list : 0,
              pathTo: "/profiles",
              title: "Profiles",
              icon: { Icon: MdSupervisorAccount, size: 21 },
              routes: [],
            },
          ],
        },
        // {
        //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
        //     props.userPermission[4].phoneNumbers.list ||
        //       props.userPermission[4].phoneNumbers.port ||
        //       props.userPermission[4].phoneNumbers.purchase ? 1 : 0 : 0,
        //   pathTo: "/phone-numbers",
        //   title: "Phone Numbers",
        //   icon: { Icon: BiPhoneCall, size: 21 },
        //   routes: [],
        // },
        // {
        //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
        //     props.userPermission[4].phoneNumbers.list ||
        //       props.userPermission[4].phoneNumbers.port ||
        //       props.userPermission[4].phoneNumbers.purchase ? 1 : 0 : 0,
        //   title: "Phone Numbers New",
        //   icon: { Icon: BiPhoneCall, size: 21 },
        //   routes: [
        //     {
        //       status: userStateData.userData?.email === "admin@efone.ca" ? 1 : 0,
        //       pathTo: "/phone-numbers-new",
        //       title: "Number Provider",
        //       icon: { Icon: BiRightTopArrowCircle, size: 21 },
        //       routes: [],
        //     },
        //     {
        //       status: userStateData.userData?.email === "admin@efone.ca" ? 1 : 0,
        //       pathTo: "/sms-providers",
        //       title: "SMS Providers",
        //       icon: { Icon: BiRightTopArrowCircle, size: 21 },
        //       routes: [],
        //     },
        //     {
        //       status: userStateData.userData?.email === "admin@efone.ca" ? 1 : 0,
        //       pathTo: "/e911Provider",
        //       title: "e911 Provider",
        //       icon: { Icon: BiRightTopArrowCircle, size: 21 },
        //       routes: [],
        //     }
        //   ],
        // },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
            props.userPermission[5].outboundProviders.list || props.userPermission[19].performanceRouting.list ||
              props.userPermission[6].inboundProviders.list || props.userPermission[17].areaCodes.list ||
              props.userPermission[7].smsProviders.list ? 1 : 0 : 0,
          title: "Providers",
          icon: { Icon: MdLibraryBooks, size: 21 },
          routes: [
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[5].outboundProviders.list : 0,
              pathTo: "/outbound-providers",
              title: "Outbound",
              icon: { Icon: BiRightTopArrowCircle, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[5].outboundProviders.list : 0,
              pathTo: "/outbound/master-prefixes/",
              title: "Provider Master Prefix",
              icon: { Icon: BiRightTopArrowCircle, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[5].outboundProviders.list : 0,
              pathTo: "/outbound/competitor-rates/",
              title: "Competitor rates",
              icon: { Icon: BiRightTopArrowCircle, size: 21 },
              routes: [],
            },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[5].outboundProviders.list : 0,
            //   pathTo: "/outbound/prefix-alerts-block/settings/",
            //   title: "prefix Alerts & block settings/",
            //   icon: { Icon: BiRightTopArrowCircle, size: 21 },
            //   routes: [],
            // },
            {
              status: 1,
              pathTo: "/outbound/termination-call-report/",
              title: "Termination Report",
              icon: { Icon: HiDocumentReport, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/providers/vendor-reports/country",
              title: "Vendor Reports",
              icon: { Icon: HiDocumentReport, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/providers/user-reports",
              title: "User Reports",
              icon: { Icon: HiDocumentReport, size: 21 },
              routes: [],
            },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : 0,
            //   pathTo: "/rates-via-email",
            //   title: "Rates via email",
            //   icon: { Icon: BiRightTopArrowCircle, size: 21 },
            //   routes: [],
            // },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[35]?.E911Providers.list : 0,
            //   pathTo: "/e911Provider",
            //   title: "E911 Provider",
            //   icon: { Icon: BiRightTopArrowCircle, size: 21 },
            //   routes: [],
            // },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[19].performanceRouting.list : 0,
            //   pathTo: "/performance_routing",
            //   title: "Performance Routing",
            //   icon: { Icon: CgPerformance, size: 21 },
            //   routes: [],
            // },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[6].inboundProviders.list : 0,
              pathTo: "/inbound-providers",
              title: "Inbound",
              icon: { Icon: BiRightDownArrowCircle, size: 21 },
              routes: [],
            },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[7].smsProviders.list : 0,
            //   pathTo: "/sms-providers",
            //   title: "SMS",
            //   icon: { Icon: BiCommentDots, size: 21 },
            //   routes: [],
            // },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[17].areaCodes.list : 0,
              pathTo: "/countryCode",
              title: "Area Codes",
              icon: { Icon: BiArea, size: 21 },
              routes: [],
            },
          ],
        },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[8].addons.list : 0,
          pathTo: "/add-ons",
          title: "Addons",
          icon: { Icon: IoIosCard, size: 21 },
          routes: [],
        },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
            props.userPermission[9].tickets.list || props.userPermission[20].suggestions.list ||
              props.userPermission[21].reviews.list || props.userPermission[22].feedback.list ? 1 : 0 : 0,
          title: "Tickets",
          icon: { Icon: TiTicket, size: 21 },
          routes: [
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[9].tickets.list : 0,
              pathTo: "/tickets",
              title: "Tickets",
              icon: { Icon: TiTicket, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[20].suggestions.list : 0,
              pathTo: "/suggestions",
              title: "Suggestions",
              icon: { Icon: FcIdea, size: 21 },
              routes: []
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[21].reviews.list : 0,
              pathTo: "/reviews",
              title: "Reviews",
              icon: { Icon: RiShieldStarLine, size: 21 },
              routes: []
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[22].feedback.list : 0,
              pathTo: "/feedback",
              title: "Feedback",
              icon: { Icon: VscFeedback, size: 21 },
              routes: []
            }
          ],
        },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
            props.userPermission[10].reports.calls ||
              props.userPermission[10].reports.sms ||
              props.userPermission[10].reports.usage ||
              props.userPermission[10].reports.callSimulation ||
              props.userPermission[10].reports.vendorReports ? 1 : 0 : 0,
          title: "Reports",
          icon: { Icon: HiDocumentReport, size: 21 },
          routes: [
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[10].reports.calls ||
                  props.userPermission[10].reports.sms ||
                  props.userPermission[10].reports.usage ? 1 : 0 : 0,
              pathTo: "/reports",
              title: "Client Reports",
              icon: { Icon: FaUserTie, size: 21 },
              routes: [],
            },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
            //     props.userPermission[10].reports.callSimulation ||
            //       props.userPermission[10].reports.vendorReports ? 1 : 0 : 0,
            //   pathTo: "/vendor-reports",
            //   title: "Vendor Reports",
            //   icon: { Icon: FaUserTag, size: 21 },
            //   routes: [],
            // },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[10].reports.calls ||
                  props.userPermission[10].reports.sms ||
                  props.userPermission[10].reports.usage ? 1 : 0 : 0,
              pathTo: "/login-errors",
              title: "Login Errors",
              icon: { Icon: VscError, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[10].reports.callSimulation ||
                  props.userPermission[10].reports.vendorReports ? 1 : 0 : 0,
              pathTo: "/login-activities",
              title: "Login Activities",
              icon: { Icon: MdLocalActivity, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: "/addons",
              title: "Addon Reports",
              icon: { Icon: IoIosCard, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[10].reports.callSimulation ||
                  props.userPermission[10].reports.vendorReports ? 1 : 0 : 0,
              pathTo: "/usage-reports",
              title: "Usage Reports",
              icon: { Icon: FaUserTag, size: 21 },
              routes: [],
            },
            // {
            //   status: props.userPermission.length > 0 ?
            //     props.userPermission[10].reports.callSimulation ||
            //       props.userPermission[10].reports.vendorReports ? 1 : 0 : 0,
            //   pathTo: "/device-provision-logs",
            //   title: "Device Provision Logs",
            //   icon: { Icon: BiDevices, size: 21 },
            //   routes: [],
            // },
          ],
        },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
            props.userPermission[11].blockedIPs.list ||
              props.userPermission[28].logSettings.list ||
              props.userPermission[27].blockedNumbers.list || props.userPermission[26].ivrSpecialNumbers.list ||
              props.userPermission[12].whiteIPs.list || props.userPermission[16].deviceProvisions.list ||
              props.userPermission[13].syncSettings.list ||
              props.userPermission[14].defaultLogSettings.list ||
              props.userPermission[15].clientDefaultSettings.list ? 1 : 0 : 0,
          title: "Security",
          icon: { Icon: IoMdConstruct, size: 21 },
          routes: [
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ?
                props.userPermission[11].blockedIPs.list ||
                  props.userPermission[12].whiteIPs.list ||
                  props.userPermission[13].syncSettings.list ||
                  props.userPermission[14].defaultLogSettings.list ||
                  props.userPermission[15].clientDefaultSettings.list ? 1 : 0 : 0,
              pathTo: "/security",
              title: "Security",
              icon: { Icon: BsShieldLock, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[16].deviceProvisions.list : 0,
              pathTo: "/deviceProvision",
              title: "Device Provisions",
              icon: { Icon: FaUsers, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[26].ivrSpecialNumbers.list : 0,
              pathTo: "/ivr_special_numbers",
              title: "Ivr Special Numbers",
              icon: { Icon: ImListNumbered, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[27].blockedNumbers.list : 0,
              pathTo: "/blocked_numbers",
              title: "Blocked Numbers",
              icon: { Icon: MdBlock, size: 21 },
              routes: [],
            },
            // {
            //   status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[28].logSettings.list : 0,
            //   pathTo: "/logs_settings",
            //   title: "Logs Settings",
            //   icon: { Icon: FiSettings, size: 21 },
            //   routes: [],
            // },
          ],
        },
        {
          status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[29].bilingSettings.list ||
            props.userPermission[31].invoices.list || props.userPermission[32].disputes.list ||
            props.userPermission[33].signupActivations.list || props.userPermission[34].addonSummary.list ? 1 : 0 : 0,
          //pathTo: "/billing",
          title: "Billing",
          icon: { Icon: FaMoneyBillAlt, size: 21 },
          routes: [
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[29].bilingSettings.list : 0,
              pathTo: "/billing",
              title: "Settings",
              icon: { Icon: AiOutlineSetting, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[31].invoices.list : 0,
              pathTo: "/invoices",
              title: "Invoices",
              icon: { Icon: FaFileInvoice, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[32].disputes.list : 0,
              pathTo: "/disputes",
              title: "Disputes",
              icon: { Icon: MdBlock, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[33].signupActivations.list : 0,
              pathTo: "/signup-activations",
              title: "Signup Activations",
              icon: { Icon: SiGnuprivacyguard, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[34].addonSummary.list : 0,
              pathTo: "/addon-summary",
              title: "Addons Summary",
              icon: { Icon: BiNotepad, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[34].addonSummary.list : 0,
              pathTo: "/freetrialsignups",
              title: "Free Trial Signups",
              icon: { Icon: PeopleIcon, size: 21 },
              routes: [],
            },
          ],
        },

        {
          status: 1,
          title: "Settings",
          icon: { Icon: SettingsIcon, size: 21 },
          routes: [
            {
              status: 1,
              pathTo: '/freetrial',
              title: "FreeTrial",
              icon: { Icon: MoneyOffIcon, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: '/clientdefaultsetting',
              title: "Client Default Settings",
              icon: { Icon: ManageAccountsIcon, size: 21 },
              routes: [],
            },
            {
              status: userStateData.userData?.email === "admin@efone.ca" ? 1 : props.userPermission.length > 0 ? props.userPermission[28].logSettings.list : 0,
              pathTo: "/logs_settings",
              title: "Logs Settings",
              icon: { Icon: FiSettings, size: 21 },
              routes: [],
            },
            {
              status: 1,
              pathTo: '/emailtriggers',
              title: "Email Trigger",
              icon: { Icon: ManageAccountsIcon, size: 21 },
              routes: [],
            },

          ],
        },



      ])
    }
    getNumberValidateErrors();
    setLoading(false)
  }, [Object.keys(props.userPermission).length, props.userPermission]);

  const getNumberValidateErrors = () => {
    axiosInstance
      .get("/admin/phone-numbers/numbers/validate/errors")
      .then((response: any) => {
        setNumberValidateErrors(response.data?.data);
      })
  }

  if (loading) return <Loader />

  return (
    <div className="side_bar_section">
      <div className="dashboard_header" onClick={() => navigateRoute('/dashboard')}>
        <div className={`dash_icon_section ${history.location.pathname === "/dashboard" && "activeBg"}`}>
          <TiHome size={21} color="grey" />
        </div>
        <div className="dash_title">
          <p className={`${history.location.pathname === "/dashboard" && "activeItem"}`}>Dashboard</p>
        </div>
      </div>
      <div className="looped_navigato">
        {
          simpleLinks.slice(1).map((links: any, i: any) => {
            if (links.status)
              return (
                <div style={{ marginTop: '5px' }} key={i}>
                  <Sidebaritem {...links} numberValidateErrors={numberValidateErrors} />
                </div>
              )
          })
        }
      </div>
      <div className="logout_footer">
        <div className="logout_btn" onClick={() => navigateRoute('/logout')}>
          <div className="logout_icon_section">
            <BiLogOut size={21} color="grey" />
          </div>
          <div className="logout_title">
            <p>Logout</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    popUpAlert: (err: any, instance: any, type: any) =>
      dispatch(popUpActionCreator.initglobalPopup(err, instance, type)),
  };
};

export default connect(null, mapDispatchToProps)(SidebarComponent);
